module.exports = __webpack_public_path__ + "static/media/male-astronaut_1f468-200d-1f680.a617bf39.png";